module.exports = __webpack_public_path__ + "img/dairy-segment.a4d9bce2.png";